import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../modules/utility';

const apiBase = 'timeClockLocation';
//const item = 'timeClockLocation';

const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	//- Get a single timeClockLocation and the list of timeClockLocations
	const timeClockLocationId = (ownProps.timeClockLocationId)
		? ownProps.timeClockLocationId
		: _.get(ownProps, ['match', 'params', 'timeClockLocationId']);
	const timeClockLocation = _.get(state.maps, ['timeClockLocation', timeClockLocationId]);

	let timeClockLocations = [];
	if (state.lists.timeClockLocationIds) {
		timeClockLocations = _.map(state.lists.timeClockLocationIds, id => state.maps.timeClockLocation[id]);
	}

	return {
		timeClockLocation,
		timeClockLocations,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getLocation : get,
	searchLocations : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
